import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgUserOutline24 = function SvgUserOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.968 23.04h20.065c-.25-5.337-4.655-9.6-10.033-9.6-5.378 0-9.781 4.263-10.032 9.6zM23 24H1v-.48c0-6.087 4.935-11.04 11-11.04s11 4.953 11 11.04V24zM12 .96c-2.637 0-4.783 2.153-4.783 4.8s2.146 4.8 4.783 4.8c2.637 0 4.783-2.153 4.783-4.8S14.637.96 12 .96zm0 10.56c-3.164 0-5.74-2.583-5.74-5.76C6.26 2.583 8.837 0 12 0c3.165 0 5.74 2.583 5.74 5.76 0 3.177-2.575 5.76-5.74 5.76z",
    fill: "currentColor"
  })));
};

var UserOutline24Svg = SvgUserOutline24;

export { UserOutline24Svg as default };
//# sourceMappingURL=UserOutline24.svg.js.map
